import React from 'react';

import CustomButton from "components/CustomButton";

import ActionButtonContentContainer from "./ActionButtonContentContainer";

function CancelButton({onClick}) {
    return (
        <CustomButton onClick={onClick} variant={'outlined'} color={'red'}>
            <ActionButtonContentContainer>
                <svg width='15' height='15' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2.5'
                     strokeLinecap='round' strokeLinejoin='round'>
                    <line x1='18' y1='6' x2='6' y2='18'/>
                    <line x1='6' y1='6' x2='18' y2='18'/>
                </svg>
                Annuler
            </ActionButtonContentContainer>
        </CustomButton>
    );
}

export default CancelButton;
